import mammoth from "mammoth";
// import express from 'express';
// import cors from 'cors';
// import { useState } from "react";
// import { AzureOpenAIClient } from "@azure/openai";
// import { AzureKeyCredential } from "@azure/core-auth";
import { OpenAIClient, AzureKeyCredential as OpenAIAzureKeyCredential } from '@azure/openai';

export const fetchAzureOpenAIData= async (file,AzureOpenAIData,GJsonFormFields)=>{
    let wordtrue=false;
    // let mammoth:any
    // let openAIClient:any;
    const openAIClient = new OpenAIClient(AzureOpenAIData?.Endpoint, new OpenAIAzureKeyCredential(AzureOpenAIData?.APIkey));
    function flattenItems(sections) {
      // Get keys of the sections object
      const sectionKeys = Object.keys(sections);
      // Reduce to flatten items from all sections
      return sectionKeys.reduce((accumulator, key) => {
        accumulator.push(...sections[key].items);
        return accumulator;
      }, []);
    }

    const extractTextFromWord = async (file: File): Promise<string> => {
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        return result.value;
      };
    
      const extractTextFromPDF = async (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
    
          reader.onload = () => {
            const result = reader.result as ArrayBuffer;
            const uint8Array = new Uint8Array(result);
            let text = '';
    
            // Basic parsing to extract raw strings - this is highly experimental and may not work as expected for complex PDFs
            for (let i = 0; i < uint8Array.length; i++) {
              if (uint8Array[i] >= 32 && uint8Array[i] <= 126) {
                text += String.fromCharCode(uint8Array[i]);
              }
            }
    
            resolve(text);
          };
    
          reader.onerror = (error) => reject(error);
          reader.readAsArrayBuffer(file);
        });
      };
    
      const extractKeyValuePairs = async (text: string): Promise<any> => {
        // const keys = ["Effective Date",
        //   "Licensee",
        //   "Harvard",
        //   "Patent Rights",
        //   "Technology",
        //   "Development Milestones",
        //   "Development Plan",
        //   "Field",
        //   "Harvard Technology Transfer Materials",
        //   "Licensed Method",
        //   "Licensed Product",
        //   "Net Sales",
        //   "Non-Royalty Sublicense Income",
        //   "Patent Rights",
        //   "Regulatory Authority",
        //   "Sublicense",
        //   "Sublicensee",
        //   "Term",
        //   "Territory",
        //   "Third Party",
        //   "Third Party Proposed Product",
        //   "Valid Claim",
        //   "License Grant",
        //   "Affiliates",
        //   "Government Rights",
        //   "AnnualLicenseMaintenanceFees",
        //   "AnnualFeeDueDate",
        //   "MilestonePayments",
        //   "MilestoneNotificationPeriod",
        //   "MilestonePaymentDuePeriod",
        //   "RoyaltyOnNetSales",
        //   "RoyaltyRate",
        //   "RoyaltyRateDuringChallenge",
        //   "NoRightToRecoupRoyalties",
        //   "ReimbursementForChallengeCosts",
        //   "NonRoyaltySublicenseIncome",
        //   "ReportsAndPayments",
        //   "ReportDueDate",
        //   "ReportIncludes",
        //   "PaymentCurrency",
        //   "ConversionRateReference",
        //   "RecordRetentionPeriod",
        //   "AuditFrequency",
        //   "UnderpaymentThresholdForAuditCostReimbursement",
        //   "LatePaymentInterest",
        //   "InterestRate",
        //   "InterestAccrualStartDate",
        // ]
        // const keys=[
        //   "Date of Agreement",
        //   "Lessor",
        //   "Lessee",
        //   "Premises Address",
        //   "Lease Term",
        //   "Renewal Notice Period",
        //   "Monthly Rent",
        //   "Rent Due Date",
        //   "Security Deposit",
        //   "Late Fee",
        //   "Permitted Use",
        //   "Prohibited Actions",
        //   "Alterations Permission",
        //   "Major Repairs Responsibility",
        //   "Minor Repairs Responsibility",
        //   "Utility Responsibility",
        //   "Insurance Requirement",
        //   "Right of Entry Notice Period",
        //   "Quarterly Inspections",
        //   "Hazardous Materials Restriction",
        //   "Noise Restriction Hours",
        //   "Lease Termination Notice Period",
        //   "Deposit Refund Period",
        //   "Governing Law",
        //   "Dispute Resolution",
        //   "Attorney’s Fees",
        //   "Annual Rent Adjustment Limit",
        //   "Emergency Equipment Maintenance",
        //   "Environmental Compliance"
        // ]
        
        const allItems = flattenItems(GJsonFormFields);
        const keys=allItems?.map(key=>key.IntName)||[];
        console.log(keys,'Keys of extracting');
        const keysPrompt = keys.map(key => `Extract the value for "${key}":`).join("\n");
        let messages;
        // const keysPrompt = keys.map(key => `${key}:`).join("\n");
        if (wordtrue) {
          messages = [
            { role: "system", content: "You are an assistant that extracts key-value pairs from documents." },
            {
              role: "user",
              content: `
              Given the following document text, extract the values for the specified keys:
      
              Keys to extract:
              ${keysPrompt}
      
              Document Text:
              ${text}  // Limit document text if it's too long

              If a value is a date, format it as "MM/DD/YYYY". Do not include ordinal suffixes, and do not return natural language. Only use given format for dates.
              Return the key-value pairs in the object format:
              Key: <value>
            `
            }
          ];
        }
        else {
          messages = [
            { role: "system", content: "You are an assistant that extracts key-value pairs from documents." },
            {
              role: "user",
              content: `
              Given the following document text, extract the values for the specified keys:
    
            Keys to extract:
            ${keysPrompt}
    
           Document Text:
            ${text}  // Limit document text if it's too long
    
            Return the key-value pairs in the object format:
            Key: <value>
          `
            }
          ];
        }
    
        try {
          const response = await openAIClient.getChatCompletions(AzureOpenAIData?.DeploymentName, messages, {
            maxTokens: 1000,
            temperature: 0,
          });
          console.log(response, "response")
          const extractedText = response.choices[0].message.content.trim();
          return extractedText;
        } catch (error) {
          console.log(error, "error")
          throw new Error(`OpenAI API call failed: ${error}`);
        }
      };
    try {
      let textContent;
      // Extract text from Word document
      //const textContent = await extractTextFromWord(file);
      if (file.type === "application/pdf") {
        // Extract text from PDF
        textContent = await extractTextFromPDF(file);
        // setwordtrue(false)
        wordtrue=false;
      } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        // Extract text from Word document
        textContent = await extractTextFromWord(file);
        wordtrue=true;
        // setwordtrue(true)
      } else {
        throw new Error("Unsupported file format. Please upload a PDF or Word document.");
      }
      // Pass extracted text to OpenAI for key-value pair extraction
      const keyValuePairs = await extractKeyValuePairs(textContent);
      console.log(keyValuePairs)
      return JSON.parse(keyValuePairs);
      // Display the extracted key-value pairs
    //   setFileContent(keyValuePairs);
    } catch (error) {
      console.error('Error processing document:', error);
      return null;
    //   setFileContent('An error occurred while processing the file.');
    }
  }

 export const fetchAIApiData=async(file,GJsonFormFields,apiUrl)=>{
    function flattenItems(sections) {
        // Get keys of the sections object
        const sectionKeys = Object.keys(sections);
        // Reduce to flatten items from all sections
        return sectionKeys.reduce((accumulator, key) => {
          accumulator.push(...sections[key].items);
          return accumulator;
        }, []);
      }

    try {
        const allItems = flattenItems(GJsonFormFields);
        let allItemsTemp = allItems.map(i => i?.IntName);
  
        const formData = new FormData();
        formData.append('file', file.split("data:application/pdf;base64,")[1]);
        formData.append('keys', JSON.stringify(allItems));
  
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            b64: file?.split("data:application/pdf;base64,")[1],
            keys: allItemsTemp
          })
        });
  
        if (!response.ok) {
          throw new Error('Failed to upload file');
        }
  
        const data = await response.json();
  
        let keyValuePairs = {};
  
        for (let key in data) {
          let updatedKey = key.replace(/ /g, '_');
          keyValuePairs[updatedKey] = data[key];
        }

          return keyValuePairs;
      } catch (error) {
        console.error("Error in fetchAIApiData:", error);
        return null;
      }
  }

  export const setContractKeysValues=(GJsonFormFields,keyValuePairs,dataText,setdataText,setcounterpartyname,optionsCounterparty,dateDatepicker,setdateDatepicker,dataNote,setdataNote,dataNumber,setdataNumber,getnumbervalue,isValidDate, setShowDurationTextField)=>{
    try{
      Object.entries(GJsonFormFields).forEach(([key1, column]: [string, { items?: any[] }]) => {
        if (column?.items) {
          column.items.forEach(itemvalue => {
            if (itemvalue.Type === "Text") {
              dataText[itemvalue.IntName] = keyValuePairs[itemvalue.IntName];
              setdataText({ ...dataText });
            }
            if (itemvalue.Type === "Plus") {
              if (keyValuePairs?.[itemvalue.IntName]) {
                const option = optionsCounterparty.filter(i => i.label === keyValuePairs?.[itemvalue.IntName]);
                if (option?.length) {
                  dataText[itemvalue.IntName] = option;
                  setdataText({ ...dataText });
                  setcounterpartyname(option);
                }
              }
            }
            if (itemvalue.Type === "DateTime") {
              dateDatepicker[itemvalue.IntName] = isValidDate(keyValuePairs?.[itemvalue.IntName])
                ? new Date(keyValuePairs?.[itemvalue.IntName])
                : null;
              setdateDatepicker({ ...dateDatepicker });
              if(itemvalue.IntName == "Contract_End_Date"){
                setShowDurationTextField(false)
              }
            }
            if (itemvalue.Type === "Note") {
              dataNote[itemvalue.IntName] = keyValuePairs?.[itemvalue.IntName];
              setdataNote({ ...dataNote });
            }
            if (itemvalue.Type === "Number") {
              let str = keyValuePairs?.[itemvalue.IntName];
              const number = parseInt(str.match(/\d+/)[0]);
              dataNumber[itemvalue.IntName] = number;
              setdataNumber({ ...dataNumber });
              getnumbervalue({
                target: {
                  value: number,
                  id: itemvalue.IntName,
                },
              });
            }
          });
        }
      });
      return true
    }catch{
      return false
    }

  }